<template>
  <div class="details">
    <div class="card br-2">
      <div class="p-10">
        <div v-if="screeningMilestones">
          <h6 class="fw-bold">SCREENING MILESTONES</h6>
          <b-row>
            <b-col cols="2" class="pl-0 pr-0 pb-10" v-for="(milestone, index) in screeningMilestones" :key="index">
              <div class="header">
                {{ milestone.milestoneName }}
              </div>
              <div class="content">Day {{ milestone.milestoneDay }}</div>
              <div class="dropdown show day_text d-flex" v-if="milestone.segments && milestone.segments.length > 0">
                <span class="dropdown-toggle studyCohort cursor_pointer" href="#" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  ><span>{{ milestone.segments.length }} Cohorts</span></span
                >
                <div>
                  <div>
                    <div class="dropdown-menu cohortDrop" disabled aria-labelledby="dropdownMenuLink">
                      <div class="dropdown-item" href="#">
                        <span class="d-block" v-for="cohort in milestone.segments" :key="cohort">
                          {{ getCohortName(cohort) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="studyCohort">
                  All Participants
                </span>
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="studyMilestones">
          <h6 class="fw-bold">STUDY MILESTONES</h6>
          <b-row>
            <b-col cols="2" class="pl-0 pr-0 pb-10" v-for="(milestone, index) in regularMilestones" :key="index">
              <div class="header">
                {{ milestone.milestoneName }}
              </div>
              <div class="content">Day {{ milestone.milestoneDay }}</div>
              <div class="dropdown show day_text d-flex" v-if="milestone.segments && milestone.segments.length > 0">
                <span class="dropdown-toggle studyCohort cursor_pointer" href="#" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  ><span>{{ milestone.segments.length }} Cohorts</span></span
                >
                <div>
                  <div>
                    <div class="dropdown-menu cohortDrop" disabled aria-labelledby="dropdownMenuLink">
                      <div class="dropdown-item" href="#">
                        <span class="d-block" v-for="cohort in milestone.segments" :key="cohort">
                          {{ getCohortName(cohort) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <span class="studyCohort">
                  All Participants
                </span>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 
IMPORTANT
Any changes made in this file should also be made in the study-milestones.vue which is inside the study-details-pdf folder
 */
export default {
  name: "milestones-details",
  data() {
    return {
      expandStudyName: false,
      expandIcon: false,
      expandColor: false
    };
  },
  components: {},
  props: {
    studyMilestones: {
      type: Array
    },
    studyData: {
      type: Object,
      default: () => {}
    },
    studyDataMilestone: {
      type: Array
    }
  },
  computed: {
    regularMilestones() {
      if (this.studyData.milestonesList) {
        if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
          const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
          filtered.forEach(mile => (mile.milestoneDay -= this.studyData.screeningDuration));
          return filtered;
        } else {
          return this.studyData.milestonesList;
        }
      }
      return [];
    },
    screeningMilestones() {
      if (this.studyData.milestonesList) {
        const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
        filtered.forEach(mile => {
          mile.milestoneDay -= this.studyData.screeningDuration;
        });
        return filtered;
      }
      return [];
    }
  },
  methods: {
    getCohortName(segmentId) {
      const selectedSegments = this.studyData.segments.find(field => {
        return field.id == segmentId;
      });
      return !!selectedSegments && selectedSegments !== 0 ? selectedSegments.name : "All Participants";
    },
    expandAll() {
      this.expandStudyName = true;
      this.expandIcon = true;
      this.expandColor = true;
    },
    collapseAll() {
      this.expandStudyName = false;
      this.expandIcon = false;
      this.expandColor = false;
    }
  }
};
</script>

<style scoped>
.header {
  font-size: 12px;
  color: #666669;
}
.content {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
.cohortDrop {
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
.studyCohort {
  font-style: italic;
  font-size: 12px;
  opacity: 0.7;
}
</style>
